import { BrowserRouter as Router } from 'react-router-dom';

export default Router;
